import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from 'components';
import * as utils from 'utils';

import styles from './IconsSocial.module.scss';

const getTypeIcon = str => {
  if (str.match(/twitter\.com/i)) return 'twitter';
  if (str.match(/(facebook\.com|fb\.com)/i)) return 'facebook';
  if (str.match(/linkedin\.com/i)) return 'linkedIn';
  if (str.match(/youtube\.com/i)) return 'youtube';
  return 'share';
};

export const IconsSocial = ({groupId, social}) => (
  <div className={styles.wrap}>
    {social.map(item => (
      <a
        key={item} target="_blank" rel="noopener noreferrer" href={item}
        onClick={() => {
          // Tracking Analytics
          const method = getTypeIcon(item);
          utils.handleAnalytics('groupSocialMediaClick', groupId, method);
        }}>
        <Icon type={getTypeIcon(item)} />
      </a>
    ))}
  </div>
);

IconsSocial.propTypes = {
  groupId: PropTypes.string.isRequired,
  social: PropTypes.arrayOf(PropTypes.string).isRequired,
};

IconsSocial.defaultProps = {};
